import type {
  PosterDetailVo,
  PosterListVo,
  PosterReplyListVo,
  PosterSimpleInfoVo,
} from '~/types/auto/forum';
import type { IdNameOption, Pagination } from '~/types/common';
import { httpService } from '../http';

/**
 * 获取讨论分类
 */
export function getPosterCategory() {
  return httpService.get<IdNameOption[]>(
    `/api/code-community-forum/api/common/posterCategory`,
  );
}

export function getPosterStatus() {
  return httpService.get(`/api/code-community-forum/api/common/posterStatus`);
}

/**
 * 讨论列表
 */
export function getPosterList(query: {
  posterCategoryId: number;
  currentPage: number;
  limit: number;
}) {
  return httpService.get<Pagination<PosterListVo>>(
    `/api/code-community-forum/api/poster/listPoster`,
    {
      query,
    },
  );
}

/**
 * 我的讨论列表
 */
export function getMyPoster(query: {
  posterType: number; // 1讨论 2题解
  posterSearchType: number; // 1我发布的 2我回复的
  zone: string;
  currentPage: number;
  limit: number;
}) {
  return httpService.get<Pagination<PosterListVo>>(
    `/api/code-community-forum/api/poster/myPoster`,
    {
      query,
    },
  );
}

export function createPost(
  query: {
    posterType: number;
  },
  data: {
    posterCategoryId: number;
    posterContent: string;
    posterName: string;
    problemId?: number;
    syncPoster?: number;
  },
) {
  return httpService.post(`/api/code-community-forum/api/poster/post`, {
    query,
    body: data,
  });
}
export function updatePost(
  data: {
    posterCategoryId: number;
    posterContent: string;
    posterName: string;
    problemId?: number;
    syncPoster?: number;
  },
  query: { posterId: number; posterType: number },
) {
  return httpService.post(`/api/code-community-forum/api/poster/update`, {
    body: data,
    query: query,
  });
}

export function getDetail(query: { posterId: number; posterType: number }) {
  return httpService.get<PosterDetailVo>(
    `/api/code-community-forum/api/poster/detail`,
    {
      query,
    },
  );
}

export function replyPoster(
  query: {
    posterId: number;
    posterType: number;
  },
  data: { replyId: number; replyContent: string },
) {
  return httpService.post<PosterReplyListVo>(
    `/api/code-community-forum/api/poster/reply`,
    {
      query: query,
      body: data,
    },
  );
}
export function giveThumb(query: {
  posterId: number;
  posterReplyId: number;
  posterType: number;
}) {
  return httpService.post(`/api/code-community-forum/api/poster/thumb`, {
    query: query,
  });
}
export function giveUnThumb(query: {
  posterId: number;
  posterReplyId: number;
  posterType: number;
}) {
  return httpService.post(`/api/code-community-forum/api/poster/unThumb`, {
    query: query,
  });
}

export function deletePoster(query: { posterId: number; posterType: number }) {
  return httpService.post(`/api/code-community-forum/api/poster/deletePoster`, {
    query: query,
  });
}

export function deleteReply(query: {
  posterId: number;
  posterReplyId: number;
  posterType: number;
}) {
  return httpService.post(`/api/code-community-forum/api/poster/deleteReply`, {
    query: query,
  });
}

export function getReplyList(query: {
  posterId: number;
  currentPage: number;
  limit: number;
  posterType: number;
}) {
  return httpService.get<Pagination<PosterReplyListVo>>(
    `/api/code-community-forum/api/poster/replyList`,
    {
      query,
    },
  );
}

export function getSimplePoster(query: { categoryId: number }) {
  return httpService.get<PosterSimpleInfoVo>(
    `/api/code-community-forum/api/poster/simplePoster`,
    {
      query,
    },
  );
}

export function getPosterView(query: { posterId: number; posterType: number }) {
  return httpService.get<PosterDetailVo>(
    `/api/code-community-forum/api/poster/view`,
    {
      query,
    },
  );
}

export function getPosterGoodsInfo() {
  const url = `/api/code-community-forum/api/poster/goodsInfo`;
  return httpService.get<PosterSimpleInfoVo>(url);
}
